module.exports = __webpack_public_path__ + "static/img/refresh.8f70f7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/refresh.gif
// module id = 8o9/
// module chunks = 1